export default __webpack_public_path__ + "static/media/thumb.d02ec5e8.png";